import {
  Building2, Trees, Shield, Stethoscope, GraduationCap, Bus,
  Droplets, Zap, Trash2, Landmark, Siren, Users, type LucideIcon,
} from "lucide-react";

export type Category =
  | "infrastructure" | "environment" | "security" | "healthcare"
  | "education" | "transportation" | "water" | "electricity"
  | "waste" | "governance" | "emergency" | "community";

export type PostType =
  | "update" | "issue" | "question" | "discussion"
  | "announcement" | "emergency" | "success" | "project";

export const CATEGORIES: Record<Category, { label: string; icon: LucideIcon; color: string }> = {
  infrastructure: { label: "Infrastructure", icon: Building2, color: "#64748B" },
  environment: { label: "Environment", icon: Trees, color: "#22C55E" },
  security: { label: "Security", icon: Shield, color: "#1E40AF" },
  healthcare: { label: "Healthcare", icon: Stethoscope, color: "#EC4899" },
  education: { label: "Education", icon: GraduationCap, color: "#8B5CF6" },
  transportation: { label: "Transportation", icon: Bus, color: "#F59E0B" },
  water: { label: "Water", icon: Droplets, color: "#0EA5E9" },
  electricity: { label: "Electricity", icon: Zap, color: "#EAB308" },
  waste: { label: "Waste", icon: Trash2, color: "#78716C" },
  governance: { label: "Governance", icon: Landmark, color: "#475569" },
  emergency: { label: "Emergency", icon: Siren, color: "#DC2626" },
  community: { label: "Community", icon: Users, color: "#2563EB" },
};

export const POST_TYPES: Record<PostType, { label: string }> = {
  update: { label: "Community Update" },
  issue: { label: "Issue Report" },
  question: { label: "Question" },
  discussion: { label: "Discussion" },
  announcement: { label: "Announcement" },
  emergency: { label: "Emergency Alert" },
  success: { label: "Success Story" },
  project: { label: "Community Project" },
};

export const CATEGORY_LIST = Object.entries(CATEGORIES).map(([key, v]) => ({
  key: key as Category, ...v,
}));

export const POST_TYPE_LIST = Object.entries(POST_TYPES).map(([key, v]) => ({
  key: key as PostType, ...v,
}));
